"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PerformerCategories;
(function (PerformerCategories) {
    PerformerCategories[PerformerCategories["HotFlirtOne"] = 8] = "HotFlirtOne";
    PerformerCategories[PerformerCategories["HotFlirtTwo"] = 9] = "HotFlirtTwo";
    PerformerCategories[PerformerCategories["NudeGirl"] = 16] = "NudeGirl";
    PerformerCategories[PerformerCategories["StraightMale"] = 17] = "StraightMale";
    PerformerCategories[PerformerCategories["GayMale"] = 18] = "GayMale";
    PerformerCategories[PerformerCategories["NudeOneFetish"] = 19] = "NudeOneFetish";
    PerformerCategories[PerformerCategories["NudeTransgender"] = 20] = "NudeTransgender";
    PerformerCategories[PerformerCategories["NudeHermaphrodite"] = 21] = "NudeHermaphrodite";
    PerformerCategories[PerformerCategories["NudeShemale"] = 22] = "NudeShemale";
    PerformerCategories[PerformerCategories["NudeMatureWoman"] = 23] = "NudeMatureWoman";
    PerformerCategories[PerformerCategories["StraightCouple"] = 24] = "StraightCouple";
    PerformerCategories[PerformerCategories["LesbianCouple"] = 25] = "LesbianCouple";
    PerformerCategories[PerformerCategories["GayCouple"] = 26] = "GayCouple";
    PerformerCategories[PerformerCategories["NudeTwoFetish"] = 27] = "NudeTwoFetish";
    PerformerCategories[PerformerCategories["NudeTwoTransgender"] = 28] = "NudeTwoTransgender";
    PerformerCategories[PerformerCategories["NudeTwoHermaphrodite"] = 29] = "NudeTwoHermaphrodite";
    PerformerCategories[PerformerCategories["NudeTwoShemale"] = 30] = "NudeTwoShemale";
    PerformerCategories[PerformerCategories["NudeThreeThreesome"] = 31] = "NudeThreeThreesome";
    PerformerCategories[PerformerCategories["NudeThreeLesbian"] = 32] = "NudeThreeLesbian";
    PerformerCategories[PerformerCategories["NudeThreeGay"] = 33] = "NudeThreeGay";
    PerformerCategories[PerformerCategories["NudeThreeFetish"] = 34] = "NudeThreeFetish";
    PerformerCategories[PerformerCategories["NudeThreeTransgender"] = 35] = "NudeThreeTransgender";
    PerformerCategories[PerformerCategories["NudeThreeHermaphrodite"] = 36] = "NudeThreeHermaphrodite";
    PerformerCategories[PerformerCategories["NudeThreeShemale"] = 37] = "NudeThreeShemale";
    PerformerCategories[PerformerCategories["NudeFourGroup"] = 38] = "NudeFourGroup";
    PerformerCategories[PerformerCategories["NudeFourLesbian"] = 39] = "NudeFourLesbian";
    PerformerCategories[PerformerCategories["NudeFourGay"] = 40] = "NudeFourGay";
    PerformerCategories[PerformerCategories["NudeFourFetish"] = 41] = "NudeFourFetish";
    PerformerCategories[PerformerCategories["NudeFourTransgender"] = 42] = "NudeFourTransgender";
    PerformerCategories[PerformerCategories["NudeFourHermaphrodite"] = 43] = "NudeFourHermaphrodite";
    PerformerCategories[PerformerCategories["NudeFourShemale"] = 44] = "NudeFourShemale";
    PerformerCategories[PerformerCategories["HotFlirtOneSingle"] = 45] = "HotFlirtOneSingle";
    PerformerCategories[PerformerCategories["HotFlirtTwoCouple"] = 46] = "HotFlirtTwoCouple";
    PerformerCategories[PerformerCategories["CelebrityOneSoulMate"] = 51] = "CelebrityOneSoulMate";
    PerformerCategories[PerformerCategories["CelebrityTwoSoulMate"] = 56] = "CelebrityTwoSoulMate";
    PerformerCategories[PerformerCategories["CelebrityOneDj"] = 85] = "CelebrityOneDj";
    PerformerCategories[PerformerCategories["CelebrityTwoDj"] = 86] = "CelebrityTwoDj";
    PerformerCategories[PerformerCategories["CelebrityOneDancer"] = 89] = "CelebrityOneDancer";
    PerformerCategories[PerformerCategories["CelebrityTwoDancer"] = 90] = "CelebrityTwoDancer";
    PerformerCategories[PerformerCategories["CelebrityOneFashion"] = 93] = "CelebrityOneFashion";
    PerformerCategories[PerformerCategories["CelebrityTwoFashion"] = 94] = "CelebrityTwoFashion";
    PerformerCategories[PerformerCategories["CelebrityOneLifeAdviser"] = 97] = "CelebrityOneLifeAdviser";
    PerformerCategories[PerformerCategories["CelebrityTwoLifeAdviser"] = 98] = "CelebrityTwoLifeAdviser";
    PerformerCategories[PerformerCategories["CelebrityOneFitness"] = 101] = "CelebrityOneFitness";
    PerformerCategories[PerformerCategories["CelebrityTwoFitness"] = 102] = "CelebrityTwoFitness";
    PerformerCategories[PerformerCategories["CelebrityOneCosplay"] = 105] = "CelebrityOneCosplay";
    PerformerCategories[PerformerCategories["CelebrityTwoCosplay"] = 106] = "CelebrityTwoCosplay";
    PerformerCategories[PerformerCategories["AmateurGirl"] = 111] = "AmateurGirl";
    PerformerCategories[PerformerCategories["AmateurBoy"] = 112] = "AmateurBoy";
    PerformerCategories[PerformerCategories["OranumBroadcasterOne"] = 134] = "OranumBroadcasterOne";
    PerformerCategories[PerformerCategories["FreeShow"] = 145] = "FreeShow";
    PerformerCategories[PerformerCategories["FreeShow1Person"] = 146] = "FreeShow1Person";
    PerformerCategories[PerformerCategories["FreeShowGirl"] = 147] = "FreeShowGirl";
    PerformerCategories[PerformerCategories["FreeShowGay"] = 148] = "FreeShowGay";
    PerformerCategories[PerformerCategories["SoulMateGayMale"] = 149] = "SoulMateGayMale";
    PerformerCategories[PerformerCategories["SoulMateStraightMale"] = 150] = "SoulMateStraightMale";
    PerformerCategories[PerformerCategories["SoulMateTransgender"] = 151] = "SoulMateTransgender";
    PerformerCategories[PerformerCategories["HotFlirtGayMale"] = 152] = "HotFlirtGayMale";
    PerformerCategories[PerformerCategories["HotFlirtStraightMale"] = 153] = "HotFlirtStraightMale";
    PerformerCategories[PerformerCategories["HotFlirtTransgender"] = 154] = "HotFlirtTransgender";
})(PerformerCategories || (PerformerCategories = {}));
var coupleCategories = [
    PerformerCategories.StraightCouple,
    PerformerCategories.LesbianCouple,
];
var amateurCategories = [
    PerformerCategories.AmateurGirl,
    PerformerCategories.AmateurBoy,
];
var freeShowCategories = [
    PerformerCategories.FreeShow,
    PerformerCategories.FreeShow1Person,
    PerformerCategories.FreeShowGirl,
    PerformerCategories.FreeShowGay,
];
var fetishCategories = [
    PerformerCategories.NudeOneFetish,
    PerformerCategories.NudeTwoFetish,
    PerformerCategories.NudeThreeFetish,
    PerformerCategories.NudeFourFetish,
];
var nonNudeCategories = [
    PerformerCategories.HotFlirtOne,
    PerformerCategories.HotFlirtTwo,
    PerformerCategories.HotFlirtOneSingle,
    PerformerCategories.HotFlirtTwoCouple,
    PerformerCategories.HotFlirtGayMale,
    PerformerCategories.HotFlirtStraightMale,
    PerformerCategories.HotFlirtTransgender,
    PerformerCategories.SoulMateGayMale,
    PerformerCategories.SoulMateStraightMale,
    PerformerCategories.SoulMateTransgender,
    PerformerCategories.CelebrityOneSoulMate,
    PerformerCategories.CelebrityTwoSoulMate,
    PerformerCategories.CelebrityOneDj,
    PerformerCategories.CelebrityTwoDj,
    PerformerCategories.CelebrityOneDancer,
    PerformerCategories.CelebrityTwoDancer,
    PerformerCategories.CelebrityOneFashion,
    PerformerCategories.CelebrityTwoFashion,
    PerformerCategories.CelebrityOneLifeAdviser,
    PerformerCategories.CelebrityTwoLifeAdviser,
    PerformerCategories.CelebrityOneFitness,
    PerformerCategories.CelebrityTwoFitness,
    PerformerCategories.CelebrityOneCosplay,
    PerformerCategories.CelebrityTwoCosplay,
    PerformerCategories.OranumBroadcasterOne,
];
var nudeCategories = [
    PerformerCategories.NudeGirl,
    PerformerCategories.StraightMale,
    PerformerCategories.GayMale,
    PerformerCategories.NudeOneFetish,
    PerformerCategories.NudeTransgender,
    PerformerCategories.NudeHermaphrodite,
    PerformerCategories.NudeShemale,
    PerformerCategories.NudeMatureWoman,
    PerformerCategories.StraightCouple,
    PerformerCategories.LesbianCouple,
    PerformerCategories.GayCouple,
    PerformerCategories.NudeTwoFetish,
    PerformerCategories.NudeTwoTransgender,
    PerformerCategories.NudeTwoHermaphrodite,
    PerformerCategories.NudeTwoShemale,
    PerformerCategories.NudeThreeThreesome,
    PerformerCategories.NudeThreeLesbian,
    PerformerCategories.NudeThreeGay,
    PerformerCategories.NudeThreeFetish,
    PerformerCategories.NudeThreeTransgender,
    PerformerCategories.NudeThreeHermaphrodite,
    PerformerCategories.NudeThreeShemale,
    PerformerCategories.NudeFourGroup,
    PerformerCategories.NudeFourLesbian,
    PerformerCategories.NudeFourGay,
    PerformerCategories.NudeFourFetish,
    PerformerCategories.NudeFourTransgender,
    PerformerCategories.NudeFourHermaphrodite,
    PerformerCategories.NudeFourShemale,
    PerformerCategories.AmateurGirl,
    PerformerCategories.AmateurBoy,
    PerformerCategories.FreeShowGirl,
    PerformerCategories.FreeShowGay,
];
var maleCategories = [
    PerformerCategories.StraightMale,
    PerformerCategories.GayMale,
    PerformerCategories.NudeTransgender,
    PerformerCategories.NudeHermaphrodite,
    PerformerCategories.NudeShemale,
    PerformerCategories.StraightCouple,
    PerformerCategories.AmateurBoy,
    PerformerCategories.FreeShowGay,
    PerformerCategories.SoulMateGayMale,
    PerformerCategories.SoulMateStraightMale,
    PerformerCategories.SoulMateTransgender,
    PerformerCategories.HotFlirtGayMale,
    PerformerCategories.HotFlirtStraightMale,
    PerformerCategories.HotFlirtTransgender,
];
var femaleCategories = [
    PerformerCategories.NudeGirl,
    PerformerCategories.NudeOneFetish,
    PerformerCategories.NudeMatureWoman,
    PerformerCategories.StraightCouple,
    PerformerCategories.LesbianCouple,
    PerformerCategories.HotFlirtOneSingle,
    PerformerCategories.CelebrityOneSoulMate,
    PerformerCategories.CelebrityOneDj,
    PerformerCategories.CelebrityOneDancer,
    PerformerCategories.CelebrityOneFashion,
    PerformerCategories.CelebrityOneLifeAdviser,
    PerformerCategories.CelebrityOneFitness,
    PerformerCategories.CelebrityOneCosplay,
    PerformerCategories.AmateurGirl,
    PerformerCategories.FreeShowGirl,
];
var hotFlirtCategories = [
    PerformerCategories.HotFlirtOne,
    PerformerCategories.HotFlirtTwo,
    PerformerCategories.HotFlirtOneSingle,
    PerformerCategories.HotFlirtTwoCouple,
    PerformerCategories.HotFlirtGayMale,
    PerformerCategories.HotFlirtStraightMale,
    PerformerCategories.HotFlirtTransgender,
];
var celebrityCategories = [
    PerformerCategories.CelebrityOneSoulMate,
    PerformerCategories.CelebrityTwoSoulMate,
    PerformerCategories.CelebrityOneDj,
    PerformerCategories.CelebrityTwoDj,
    PerformerCategories.CelebrityOneDancer,
    PerformerCategories.CelebrityTwoDancer,
    PerformerCategories.CelebrityOneFashion,
    PerformerCategories.CelebrityTwoFashion,
    PerformerCategories.CelebrityOneLifeAdviser,
    PerformerCategories.CelebrityTwoLifeAdviser,
    PerformerCategories.CelebrityOneFitness,
    PerformerCategories.CelebrityTwoFitness,
    PerformerCategories.CelebrityOneCosplay,
    PerformerCategories.CelebrityTwoCosplay,
];
var getCategoryLabelById = function (id) {
    var categoryLabel = PerformerCategories[id];
    if (!categoryLabel) {
        console.error("performer-category: unable to find category id \"".concat(id, "\""));
        return '';
    }
    return categoryLabel;
};
var getCategoryIdByLabel = function (label) {
    var categoryId = parseInt(PerformerCategories[label], 10);
    if (!categoryId) {
        console.error("performer-category: unable to find category label \"".concat(label, "\""));
        return 0;
    }
    return categoryId;
};
var getCategoryIdFromIdOrLabel = function (idOrLabel) {
    if (!idOrLabel) {
        return 0;
    }
    var id = typeof idOrLabel === 'number' ? idOrLabel : parseInt(idOrLabel, 10);
    if (!id) {
        return getCategoryIdByLabel(idOrLabel.toString());
    }
    if (!PerformerCategories[id]) {
        console.error("performer-category: unable to find category id \"".concat(id, "\""));
        return 0;
    }
    return id;
};
var isSingleCategory = function (idOrLabel) {
    return idOrLabel && !coupleCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isCoupleCategory = function (idOrLabel) {
    return coupleCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isAmateurCategory = function (idOrLabel) {
    return amateurCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isFreeShowCategory = function (idOrLabel) {
    return freeShowCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isFetishCategory = function (idOrLabel) {
    return fetishCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isNonNudeCategory = function (idOrLabel) {
    return nonNudeCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isNudeCategory = function (idOrLabel) {
    return nudeCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isMaleCategory = function (idOrLabel) {
    return maleCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isFemaleCategory = function (idOrLabel) {
    return femaleCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isHotFlirtCategory = function (idOrLabel) {
    return hotFlirtCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var isCelebrityCategory = function (idOrLabel) {
    return celebrityCategories.includes(getCategoryIdFromIdOrLabel(idOrLabel));
};
var performerCategory = {
    values: PerformerCategories,
    groups: {
        couple: coupleCategories,
        amateur: amateurCategories,
        freeShow: freeShowCategories,
        fetish: fetishCategories,
        nonNude: nonNudeCategories,
        nude: nudeCategories,
        male: maleCategories,
        female: femaleCategories,
        hotFlirt: hotFlirtCategories,
        celebrity: celebrityCategories,
    },
    get: {
        labelById: getCategoryLabelById,
        idByLabel: getCategoryIdByLabel,
    },
    is: {
        single: isSingleCategory,
        couple: isCoupleCategory,
        amateur: isAmateurCategory,
        freeShow: isFreeShowCategory,
        fetish: isFetishCategory,
        nonNude: isNonNudeCategory,
        nude: isNudeCategory,
        male: isMaleCategory,
        female: isFemaleCategory,
        hotFlirt: isHotFlirtCategory,
        celebrity: isCelebrityCategory,
    },
};
exports.default = performerCategory;
